import React from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {ReactComponent as Chevron} from '../../assets/arrow.svg';
import {ReactComponent as CloseIcon} from '../../assets/close.svg';
import {debugCNitoUrl} from '../../helpers';

const DKidsHeader = ({paddingTop}) => {
    const history = useHistory();
    const {t} = useTranslation();

    if (
        history.location.pathname.indexOf('/play') >= 0 ||
        history.location.pathname.indexOf('/now/') >= 0 ||
        history.location.pathname.indexOf('/politica-de-privacidade') >= 0 ||
        history.location.pathname.indexOf('/politica-de-privacidad') >= 0 ||
        history.location.pathname.indexOf('/termos-de-uso') >= 0 ||
        history.location.pathname.indexOf('/terminos-de-uso') >= 0
    ) {
        return (
            <Container paddingTop={paddingTop}>
                <Content>
                    <ChevronIcon
                        title={t('controls.goback')}
                        onClick={() => history.goBack()}
                    />
                </Content>
            </Container>
        );
    }

    const showCloseButton = history.location.pathname.indexOf('/game') >= 0;

    const goHome = () => {
        history.push(`/${debugCNitoUrl()}`);
    };

    return (
        <Container paddingTop={paddingTop}>
            <Content>
                <Logo onClick={goHome} />
                <Spacer />
                {showCloseButton && (
                    <CloseButton to={`/${debugCNitoUrl()}`}>
                        <CloseIcon title={t('games.exitModal.exitGame')} />
                    </CloseButton>
                )}
            </Content>
        </Container>
    );
};

const Container = styled.header`
    position: fixed;
    display: flex;
    width: 100%;
    height: 138px;
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.4) 0%,
        rgba(19, 35, 144, 0) 77.94%
    );

    flex-direction: row;
    justify-content: center;
    z-index: 100;
    padding: 0;
    pointer-events: box-none;
    ${props => props.paddingTop && `padding-top: ${props.paddingTop}px;`}
`;

const Content = styled.div`
    max-width: 1440px;
    display: flex;
    flex: 1;
    padding: 28px 25px 0px 25px;
`;

const Logo = styled.img.attrs({
    src: require('../../assets/dkids/dkids_logo.png'),
})`
    width: 51px;
    height: 52px;
    cursor: pointer;
`;

const ChevronIcon = styled(Chevron)`
    margin-left: -7px;
    width: 28px;
    height: 28px;
    margin: 0px;

    transform: scaleX(-1);
    path {
        fill: #fff;
    }
    pointer-events: all;
    cursor: pointer;
`;

const CloseButton = styled(Link)`
    width: 28px;
    height: 28px;
    g {
        fill: #fff;
    }
    pointer-events: all;
`;

const Spacer = styled.span`
    flex: ${props => (props.ratio ? props.ratio : 1)};
`;

export default DKidsHeader;
